import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import "./ANWEC.css";

import photo1 from "../../images/projects/sec/img (1).jpg";
import photo2 from "../../images/projects/sec/img (2).jpg";
import photo3 from "../../images/projects/sec/img (3).jpg";
import photo4 from "../../images/projects/sec/img (4).jpg";
import photo5 from "../../images/projects/sec/img (5).jpg";
import photo6 from "../../images/projects/sec/img (6).jpg";
import photo7 from "../../images/projects/sec/img (7).jpg";
import photo8 from "../../images/projects/sec/img (8).jpg";
import photo9 from "../../images/projects/sec/img (9).jpg";
import photo10 from "../../images/projects/sec/img (10).jpg";
import photo11 from "../../images/projects/sec/img (11).jpg";
import photo12 from "../../images/projects/sec/img (12).jpg";
import photo13 from "../../images/projects/sec/img (13).jpg";
import photo14 from "../../images/projects/sec/img (14).jpg";
import photo15 from "../../images/projects/sec/img (15).jpg";
import photo16 from "../../images/projects/sec/img (16).jpg";


function ANWEC() {
  useEffect(() => {
    AOS.init({ 
      duration: 1200,
      once: true,
      easing: 'ease-out-cubic'
    });
  }, []);
  const photos = [
    {
      src: photo1,
      alt: "Sedaqat Educational Center classroom",
      title: "Sedaqat Educational Center",
      description: "Providing quality education to 140 students in Dasht-e-Barchi."
    },
    {
      src: photo2,
      alt: "Students learning at SEC",
      title: "Daily Learning Sessions",
      description: "Eight hours of comprehensive daily lessons in multiple subjects."
    },
    {
      src: photo3,
      alt: "SEC classroom environment",
      title: "Modern Learning Environment",
      description: "Well-equipped classrooms fostering academic excellence."
    },
    {
      src: photo4,
      alt: "Teachers and students",
      title: "Dedicated Educators",
      description: "Experienced teachers committed to student success."
    },
    {
      src: photo5,
      alt: "Student activities",
      title: "Interactive Learning",
      description: "Engaging educational activities for grades 1-6."
    },
    {
      src: photo6,
      alt: "Educational materials",
      title: "Learning Resources",
      description: "Books, stationery, and supplies for all students."
    },
    {
      src: photo7,
      alt: "SEC facility",
      title: "Safe Learning Space",
      description: "A secure and welcoming environment for children."
    },
    {
      src: photo8,
      alt: "Group learning",
      title: "Collaborative Education",
      description: "Students working together to achieve academic goals."
    },
    {
      src: photo9,
      alt: "Classroom instruction",
      title: "Quality Teaching",
      description: "Professional instruction in English, Math, and Pashto."
    },
    {
      src: photo10,
      alt: "Students studying",
      title: "Focused Learning",
      description: "Students developing essential skills for their future."
    },
    {
      src: photo11,
      alt: "Educational program",
      title: "Comprehensive Curriculum",
      description: "From basic principles to advanced subjects."
    },
    {
      src: photo12,
      alt: "SEC community",
      title: "Building Community",
      description: "Creating a supportive learning community for all."
    },
    {
      src: photo13,
      alt: "Student achievement",
      title: "Academic Success",
      description: "Celebrating student progress and achievements."
    },
    {
      src: photo14,
      alt: "Learning activities",
      title: "Engaging Programs",
      description: "Dynamic educational activities that inspire learning."
    },
    {
      src: photo15,
      alt: "SEC staff",
      title: "Dedicated Team",
      description: "Manager, assistant manager, teachers, and support staff."
    },
    {
      src: photo16,
      alt: "Educational excellence",
      title: "Excellence in Education",
      description: "Empowering the next generation through quality education."
    }
  ];

  return (
    <div>
      <h1 className="anwec" data-aos="fade-down">
        <span className="anwec-title-text">Action Not Word Educational Center</span>
      </h1>

      <div className="aboutanwec" data-aos="fade-up">
        <h1 data-aos="fade-down" data-aos-delay="100">About Our Course</h1>
        <div className="donateSection">
          <p data-aos="fade-up" data-aos-delay="200">
            Located in the Qasaba area and managed by Walid Hoida, the Action Not Word Educational 
            Course offers comprehensive lessons in religious subjects, sewing, drawing, English, and 
            mathematics. This unique program combines academic education with practical vocational 
            skills, preparing students for both intellectual growth and real-world success. The program 
            provides students with both the academic knowledge and practical skills that will serve them 
            throughout their lives. With monthly operating expenses of approximately $300, we are committed 
            to supporting quality education and skill development for our students, ensuring they have the 
            tools they need to build successful futures.
          </p>
        </div>
      </div>

      <hr />

      <div className="carousel-section" data-aos="fade-up">
        <h2 className="carousel-title" data-aos="fade-down" data-aos-delay="100">
          Our Photo Gallery
        </h2>
        <div data-aos="zoom-in" data-aos-delay="200">
          <Carousel 
            showArrows={true} 
            showThumbs={false} 
            infiniteLoop={true} 
            autoPlay={true} 
            interval={4000} 
            transitionTime={800} 
            showStatus={false}
          >
            {photos.map((photo, index) => (
              <div className="photo-section" key={index}>
                <h2 className="photo-title">{photo.title}</h2>
                <p className="photo-text">{photo.description}</p>
                {photo.src && <img src={photo.src} alt={photo.alt} className="photo" />}
              </div>
            ))}
          </Carousel>
        </div>
      </div>

      <hr />
      
      <div className="whatWeDo" data-aos="fade-up">
        <h1 data-aos="fade-down" data-aos-delay="100">Our Programs & Curriculum</h1>
        <p data-aos="fade-up" data-aos-delay="200">
          <strong>Our Mission:</strong> Holistic Education for Life Success<br/><br/>
          At Action Not Word Educational Course, we believe in developing well-rounded individuals through 
          a diverse curriculum that balances academic excellence with practical skills. Our programs include:<br/><br/>
          <strong>• Religious Studies:</strong> Teaching fundamental Islamic principles and values that guide 
          moral and ethical development.<br/><br/>
          <strong>• Vocational Skills - Sewing:</strong> Providing practical training in sewing and tailoring, 
          enabling students to develop marketable skills for economic independence.<br/><br/>
          <strong>• Creative Arts - Drawing:</strong> Fostering creativity and self-expression through 
          comprehensive art and drawing classes.<br/><br/>
          <strong>• English Language:</strong> Building essential communication skills through structured 
          English language instruction.<br/><br/>
          <strong>• Mathematics:</strong> Developing analytical thinking and problem-solving abilities through 
          comprehensive math education.<br/><br/>
          <strong>• Affordable Education:</strong> Operating efficiently with $300 monthly expenses while 
          maintaining quality instruction across all subjects.<br/><br/>
          Our integrated approach ensures students receive both the knowledge and practical skills needed 
          to thrive in their communities and pursue their dreams.
        </p>
      </div>
    </div>
  );
}

export default ANWEC;